import React from 'react';
import usePersistedKeyValueStore from '../../hooks/usePersistedKeyValueStore';
import { AnimateLoadedContent } from '../v2BaseComponents/Loader';

export type UseSideDrawerCollapsedState = {
    isCollapsed: boolean;
    setIsCollapsed: (isCollapsed: boolean) => void;
};

export const SideDrawerCollapsedStateContext = React.createContext<UseSideDrawerCollapsedState>({
    isCollapsed: false,
    setIsCollapsed: () => {},
});

export const SideDrawerCollapsedStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const {
        value: isCollapsed,
        setValue: setIsCollapsed,
        isLoading,
    } = usePersistedKeyValueStore({
        category: 'drawer',
        key: 'drawerCollapsed',
        defaultValue: false,
    });

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <SideDrawerCollapsedStateContext.Provider value={{ isCollapsed, setIsCollapsed: setIsCollapsed }}>
                    {children}
                </SideDrawerCollapsedStateContext.Provider>
            )}
        </AnimateLoadedContent>
    );
};
